// @docs https://[domain]/api/v1/docs
export default {
  ReportOvertime: "/pyr/reports/overtimes",
  ReportAttendance: "/pyr/reports/attendances",
  ReportLeave: "/pyr/reports/employee-leaves",

  ReportReconcile: "/pyr/reports/payrolls-reconcile",

  ReportPayrollSummary: "/pyr/reports/payrolls-summary",

  ReportSHUIContribution: "/pyr/reports/shui-contribution",
  ReportPITSummary: "/pyr/reports/pit-summary",

  ReportOneStream: "/pyr/reports/one-stream",

  ReportEmployeeProfile: "/pyr/reports/employee-profiles/{id}",

  ReportDiligence: "/pyr/reports/diligence",

  ReportLaborManagementBook: "/pyr/reports/labor-management-book",
};
